import React from 'react';
import classnames from 'classnames';
import DonnutChart from 'common/components/donnut_chart';
import Tooltip from 'react-tooltip';
import { isMobile } from 'common/utils';
import { v4 } from 'node-uuid';

const ReputationChart = ({ reputation, containerClass, chartClass, withTooltip=false }) => {
  let chartClasses;
  const key = v4();

  if (reputation >= 90) {
    chartClasses = "elite";
  } else if (reputation >= 80) {
    chartClasses = "platinum";
  } else if (reputation >= 50) {
    chartClasses = "standard";
  }

  return (
    <div className={classnames("reputation-chart-wrapper", { "with-tooltip": withTooltip })}
      data-tip={withTooltip} data-for={`rep-tooltip-${key}`}
      data-event={isMobile()? "click" : undefined}>

      { withTooltip &&
      <Tooltip class="tooltip" effect="solid" place="right" id={`rep-tooltip-${key}`}>
        Creatives with a reputation from 80 to 100 reflect the best,<br/>
        most experienced creatives on crowdspring, as measured by<br/>
        the quality of their work.<br/>
        Reputation score is a broad measurement tool. Look at a creative's<br/>
        profile and portfolio to see if their style more closely meets what<br/>
        you're looking for.
      </Tooltip> }

      <DonnutChart percentage={reputation} containerClass={containerClass}
        chartClass={classnames(chartClass, chartClasses)}>
        <span className="reputation-value">{Math.floor(reputation)}</span>
      </DonnutChart>
    </div>
  );
}

export default ReputationChart;



// WEBPACK FOOTER //
// ./common/components/reputation_chart.jsx